import Cookie from "./cookie";

export default class CityCheck {
    constructor() {
        this.cookie = new Cookie();
        this.initListeners();
        this.init();
    }

    init() {
        const shown = this.cookie.getCookie('is-city-check-shown');
        const disabled = parseInt(document.querySelector('.city-check').dataset.disabled);
        if (!disabled && !shown) {
            this.show();
        }
    }

    initListeners() {
        document.querySelector('.city-check').addEventListener('click', (e) => {
            if (e.target.classList.contains('city-check__button')) {
                this.cookie.setCookie('is-city-check-shown', true);
            }
            this.hide();
        })
    }

    show() {
        setTimeout(() => {
            document.querySelector('main').classList.add('blured');
            document.querySelectorAll('.city-check')?.forEach(box => { box.style.display = 'block' })
        }, 0)
    }

    hide() {
        document.querySelectorAll('.city-check')?.forEach(box => { box.style.display = 'none' })
        document.querySelector('main').classList.remove('blured');
    }
}
